var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 20 18","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7 0L5.17 2H2C.9 2 0 2.9 0 4v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-3.17L13 0H7zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-1.8a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4z"}})])};var toString = function () {return "/app/static/svg/icon_photo.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./static/svg/icon_photo.svg
// module id = 773
// module chunks = 3 37 47 48 49 50 52 53 54 55 56 57 58 59 60 62 65 67